import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { getAccountById, updateAccount } from '../../actions/accountActions';
import { getAllReportsByProject } from '../../actions/reportActions';
import MainWrapper from '../../components/MainWrapper';
import Message from '../../utils/Message';
import Loader from '../../utils/Loader';
import { useParams } from 'react-router-dom';
import DriveWrapper from './components/DriveWrapper';

const UpdateAccount = ({ match }) => {
  const dispatch = useDispatch();
  const searchParams = useParams();
  const { id, projectId } = searchParams; // either mongo Id or, slug

  useEffect(() => {
    if (id) {
      dispatch(getAccountById(id));
    }
    if (projectId) {
      dispatch(getAllReportsByProject(projectId));
    }
  }, [dispatch, projectId, id]);

  const { account, updated, loading, error } = useSelector(
    (state) => state.accountR
  );
  const { reports } = useSelector((state) => state.reportR);
  const [reportList, setReportList] = useState([]);
  const [selected, setSelectedReport] = useState([]);
  const [newPassword, setNewPassword] = useState('');
  const [accounts, setAccounts] = useState({
    username: '',
    password: '',
    report2Access: [],
    role: '',
    projectId: '',
  });

  useEffect(() => {
    if (reports) {
      const newArr = reports.map((e) => {
        return {
          label: e.name,
          value: e._id,
        };
      });
      setReportList(newArr);
    }
  }, [reports]);

  useEffect(() => {
    if (account) {
      setAccounts(account);
      setSelectedReport([account.report2Access]);
    }
  }, [account]);

  const onChange = (e) => {
    const { name, value } = e.target;
    const acc = { ...accounts };
    acc[name] = value;
    setAccounts(acc);
  };

  function addEditProperty(item) {
    setSelectedReport({ 0: item });
    const acc = { ...accounts };
    acc['report2Access'] = item;
    setAccounts(acc);
  }

  function onFormSubmit(e) {
    e.preventDefault();
    if (newPassword) {
      const acc = { ...accounts };
      acc.password = newPassword;
      dispatch(updateAccount({ account: acc }));
    } else {
      dispatch(updateAccount({ account: accounts }));
    }
  }
  function back() {
    return window.history.back();
  }

  // console.log('reports', reports);

  return (
    <DriveWrapper>
      {error ? (
        <Message color="danger"> {error} </Message>
      ) : (
        <div className="container">
          {loading && <Loader />}
          {updated && <Message color="success"> Successful update. </Message>}

          <div className="card p-5 mb-2 container">
            <div className="mb-4">
              <button onClick={back} className="btn btn-primary">
                Back
              </button>
            </div>
            <h5 className="lead text-center shadow py-2">Update Account</h5>

            {accounts && (
              <form style={{ padding: '5%' }} onSubmit={onFormSubmit}>
                <div>
                  <label htmlFor="username">
                    Your Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    placeholder="Enter user name"
                    value={accounts.username}
                    onChange={(e) => onChange(e)}
                    required
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="newPassword">Update Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="newPassword"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>

                <div className="mt-3">
                  <label htmlFor="name">
                    Report To Access <span className="text-danger">*</span>
                  </label>
                  <Select
                    isMulti={true}
                    value={selected[0]}
                    onChange={(e) => addEditProperty(e)}
                    options={reportList}
                    required
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="name">Permission Level</label>
                  <select
                    value={accounts.role}
                    name="role"
                    className="form-select"
                    onChange={(e) => onChange(e)}
                    required
                  >
                    <option value="">Select</option>
                    <option value="admin">Admin</option>
                    <option value="validator">Validator</option>
                    <option value="dev">Dev</option>
                  </select>
                </div>

                <div className="d-flex justify-content-between mt-3">
                  <button className="btn btn-primary" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </DriveWrapper>
  );
};

export default UpdateAccount;
